import { useState } from "react";
import { InputFile } from "../../Atoms/Inputs/InputFile";
import * as S from "./styles";
import { IFileCustom } from "../../Atoms/Inputs/InputFile/useInputFile";
import { textFileTruncate } from "../../../utils/textTruncate";
import { IconDoc } from "./icons/iconDoc";
import { IconAudio } from "./icons/iconAudio";
import { ButtonCustom } from "../../Atoms/ButtonCustom/buttonCustom";
import { FormStateNumber } from "../../Pages/complaint/useComplaint";
import { useSearchParams } from "react-router-dom";
import { Denuncia } from "../../../services/Denuncia";
import { useContextSite } from "../../../context/Context";
import { toast } from "react-toastify";
import { IArquivoDTO } from "../../../types/denuncia";

const TypeAudio = ["mp3", "wav", "ogg"];
const TypeImages = ["jpg", "jpeg", "png", "gif", "webp"];

interface IUploadFile {
  handleNext: (n: FormStateNumber) => void;
}
export const UploadFile = ({ handleNext }: IUploadFile) => {
  const [searchParam] = useSearchParams();
  const id = searchParam.get("uuid");
  const { setIsLoad } = useContextSite();
  const [files, setFiles] = useState<IArquivoDTO[]>([]);

  function handleAddFile(file: IFileCustom) {
    if (!id) return;
    setIsLoad(true);

    Denuncia.vincular_arquivo({ uuidDenuncia: id, arquivo: file.file })
      .then(({ data }) => {
        setFiles(data.arquivos);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  const getFileExtension = (filename: string): string => {
    return filename.split(".").pop()?.toLowerCase() || "";
  };

  const hasImagem = (file: IArquivoDTO): boolean => {
    const extension = getFileExtension(file.fileName);
    return TypeImages.includes(extension);
  };

  function handleRemove({ uuidArquivo }: { uuidArquivo: string }) {
    if (!id) return;

    setIsLoad(true);
    Denuncia.desvincular_arquivo({ uuidDenuncia: id, uuidArquivo })
      .then(({ data }) => setFiles(data.arquivos))
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  return (
    <S.UploadFilePageStyles>
      <div>
        <h2>Anexar Arquivos </h2>
      </div>

      <S.WraperInputFile>
        <InputFile
          onChange={(file) => file && handleAddFile(file)}
          fileTypes={[...TypeAudio, ...TypeImages]}
        />
      </S.WraperInputFile>

      <S.WraperFiles>
        {files?.length > 0 &&
          files.map((file) => (
            <S.FileStyle key={file?.absolutePath}>
              {hasImagem(file) ? <IconDoc /> : <IconAudio />}
              <p>{textFileTruncate({ text: file?.fileName, limit: 14 })}</p>
              <span onClick={() => handleRemove({ uuidArquivo: file.uuid })}>
                X
              </span>
            </S.FileStyle>
          ))}
      </S.WraperFiles>

      <S.WrapperButton>
        <ButtonCustom
          onClick={() => {
            handleNext(3);
          }}
        >
          Concluir
        </ButtonCustom>
      </S.WrapperButton>
    </S.UploadFilePageStyles>
  );
};
